import { InfoCard } from "../InfoCard"
import { LabelRow } from "../LabelRow"
import { useEffect, useState } from "react"
import { Select } from "antd"
import { putSimRXSET } from "@/services/project/simulation.service"
import { DivNumberInput } from "@/components/DivInput/DivNumberInput"
import { getFlowSimulationSelector } from "@/store/flowsheet/flowsheet.slice"
import { useSelector } from "react-redux"

interface ReactSetSelectProps {
  data: any,
  unitId: string,
  reload?: () => void
}

export const ReactSetSelect = (props: ReactSetSelectProps) => {
  const {unitId, data, reload} = props;
  const sets = data?.args?.['tpps-rxsets'] ?? []
  const rxset = data?.args?.rxset;
  const [pSetId, setPsetId] = useState<string>(rxset)
  const flowSimulation = useSelector(getFlowSimulationSelector)
  const reactions = data?.args?.rxate ?? []

  useEffect(() => {
    setPsetId(rxset)
  }, [rxset])

  const onSelected = (val: string) => {
    setPsetId(val);
    putSimRXSET({rxset: val, unit: unitId}, {sId: flowSimulation?.id}).then(() => {
      reload?.()
    })
  }

  const setOptions = sets.map(item => {
    return {label: item, value: item}
  })

  const onAteChanged = (reaction, val) => {
    const args = reactions.map(({rx, ate}) => {
      let itemVal = ate;
      if (rx === reaction.rx) {
        itemVal = val
      }
      return {
        rx: rx,
        val: itemVal
      }
    })

    putSimRXSET({rxset: pSetId, unit: unitId, rxates: args}, {sId: flowSimulation?.id}).then(() => {
      reload?.()
    })
  }


  return <div>
    <LabelRow label="Reaction set" value={
      <Select options={setOptions} value={pSetId} style={{width: 120}} onChange={onSelected}/>
    }/>
    <InfoCard title='Equilibrium Reaction ATES' className="mt-1">
      {reactions.map(reaction => {
        return <div className="flex-start bordered mt-1">
          <div style={{flex: 1}} className="p-1">{reaction.rx || '-'}</div>
          <div style={{borderLeft: '1px solid #eee', flex: 1}} className="p-1">
            <DivNumberInput style={{width: '100%'}} value={reaction.ate} removeAble={false} onChange={(val) => onAteChanged(reaction, val)} />
          </div>
        </div>
      })}
    </InfoCard>
  </div>
}